export default __webpack_public_path__ + "static/media/turismoManu.689585e8.jpg";